import { render } from "./persistentvolume.vue?vue&type=template&id=124d28bc&ts=true"
import script from "./persistentvolume.vue?vue&type=script&lang=ts"
export * from "./persistentvolume.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__